export const SESSION_HINT_COOKIE = 'pickpro_session';
export const SESSION_HINT_VALUE = '1';

export const hasSessionHint = (): boolean => {
  try {
    if (typeof document === 'undefined') return false;
    return document.cookie
      .split(';')
      .some((entry) => entry.trim() === `${SESSION_HINT_COOKIE}=${SESSION_HINT_VALUE}`);
  } catch {
    return false;
  }
};
